document.addEventListener("DOMContentLoaded", function () {
  document.querySelector('.modal-video').addEventListener('click', function(e){  
    const innerIframe = document.querySelector('#info-with-media .modal-video iframe')
    const innerVideo = document.querySelector('#info-with-media .modal-video video')
    if ((innerVideo && !innerVideo?.contains(e.target)) || (innerIframe && !innerIframe?.contains(e.target))){
      var modal = document.querySelector('.modal-video');
      modal.classList.toggle('show');
  
      var video = modal.querySelector('video');
      if (video !== null) {
        if (!modal.classList.contains('show')) {
          video.pause();
        }
      } else {
        var iframe = modal.querySelector('.iframeVideo');
        if (iframe !== null) {
           iframe.contentWindow.postMessage( '{"event":"command", "func":"pauseVideo", "args":""}', '*');  
        }
      }
    } 
  }); 

  document.getElementById('playVideo').addEventListener('click', function () {
    var modal = document.querySelector('.modal-video');
    modal.classList.toggle('show');

    var video = modal.querySelector('video');
    if (video !== null) {
      if (modal.classList.contains('show')) {
        setTimeout(() => {
          video.play();
        }, 1000);
      } else {
        video.pause();
      }
    } else {
      var iframe = modal.querySelector('.iframeVideo');
      if (iframe !== null) {
        iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
      }
    }
  });
});
